module.exports = __webpack_public_path__ + "img/diamond-card.0ee09350.png";